import { FC, useState } from 'react';
import { Button } from 'antd';
import { postAddCart } from '@base/product/services';
import { useStore } from 'base/store';
import Message from '@base/lib/Message';
import styles from './index.module.less';
import { TActivityStatus } from 'base/utils/flashsale';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';

type IProps = {
    variantId: string;
    activityStock: number;
    status: TActivityStatus;
    getImgSrc: () => string | undefined | null;
    userLimit: number;
};

function getBtnText(status: TActivityStatus, activityStock: number): string {
    if (status === 'notStarted') {
        return 'web_home_sfs_btn_coming_soon_capfirst';
    }
    if (status === 'ended') {
        return 'web_home_sfs_btn_sale_is_ove_capfirst';
    }
    if (activityStock === 0) {
        return 'web_product_sold_out';
    }
    return 'web_product_add_to_cart';

}

export const ProductOptions: FC<IProps> = props => {
    const { variantId, activityStock, status, getImgSrc, userLimit } = props;
    const [loading, setLoading] = useState(false);
    const { miniCartStore } = useStore();
    const { t } = useTrans();

    const canBuy = activityStock > 0 && status === 'inProgress';

    const handleAddToCart = async () => {
        setLoading(true);

        try {
            const res = await postAddCart([
                {
                    productVariantId: variantId,
                    num: 1
                }
            ]);
            if (!res.addFailProductName || res.addFailProductName.length === 0) {
                const src = getImgSrc();
                miniCartStore.afterAddCart(1, src ? [src] : void 0);
            } else {
                Message.error(t('web_product_unavailable_error', {
                    productName: res.addFailProductName[0]
                }));
            }
        } catch (e) {
            Message.error(e.message);
        }

        setLoading(false);
    };

    return (
        <>
            <Button
                size={'small'}
                type={'primary'}
                block
                disabled={!canBuy}
                loading={loading}
                onClick={handleAddToCart}
                className={styles.btn}
            >
                {t(getBtnText(status, activityStock))}
                {canBuy && (
                    <div className={cn(styles['purchase-tip'], 'g-sfs-purchase-tip')}>
                        ({t('web_home_sfs_purchase_limit', { userLimit })})
                    </div>
                )}
            </Button>
        </>
    );
};